export default __webpack_public_path__ + "static/media/mc-logo.baf0825d.svg";